
import Header from '~/components/layouts/Header';
import {
  AppMixin,
  CartMixin,
  CategoriesListMixin,
  CmsMetaMixin,
  CmsMixin,
  UserAuthMixin,
  UserMixin,
  WishlistMixin,
} from '~/node_modules/sitis-nuxt/lib/mixins';
import { metaData } from '~/helpers/meta-data';

export default {
  name: 'LayoutDefault',

  fetch: async function () {
    await this.getMenu();
    await this.getCatalog();
  },

  head: function () {
    const meta = this.headerMetaAsync;
    const canonical = this.getCanonical;

    const link = [
      { rel: 'icon', type: 'image/svg+xml', href: this.appCfg?.favicon },
    ];
    if (canonical) {
      link.push({ rel: 'canonical', href: canonical });
    }

    return {
      meta: [...meta],
      link: [...link],
    };
  },

  mixins: [
    AppMixin,
    UserMixin,
    UserAuthMixin,
    CartMixin,
    CmsMetaMixin,
    CmsMixin,
    WishlistMixin,
    CategoriesListMixin,
  ],

  computed: {
    headerMetaAsync: function () {
      const config = this.$store.state?.appState?.config;
      const headMeta = config?.head?.meta || [];

      let meta = [];

      headMeta.forEach((item) => {
        meta.push(
          { name: item.name, content: item.content },
        );
      });

      meta = [
        ...meta,
        ...metaData({
          logoLink: this?.appCfg?.logoFront || '',
          pageSlug: this.$route.fullPath || '',
          pageTitle: this?.page?.page?.title || '',
          pageDescription: this?.page?.page?.description || '',
        }),
      ];

      return meta;
    },
    countersFooter: function () {
      return this.appCfg?.counters?.footer || '';
    },
    getCanonical: function () {
      if (this.$route.name === 'catalog-all') {
        return '';
      }

      const host = `https://${this.$store.state?.['local-settings']?.headers?.host}/`;
      const fullPath = (this.$route?.fullPath || '').substring(1);

      return [host, fullPath]
        .filter((t) => !!t)
        .join('')
        .split('?')?.[0];
    },

    isPopUpCmsPage: function () {
      return Boolean(this.$store.state['pop-up-cms-page']?.cmsPageId || '');
    },
  },

  components: {
    Header: Header,
    Footer: () => import('~/components/layouts/Footer'),
    PopUpSearch: () => import('~/components/layouts/PopUpSearch'),
    PopUpBackCall: () => import('~/components/layouts/PopUpBackCall'),
    PopUpImages: () => import('~/components/layouts/PopUpImages'),
    PopUpLoading: () => import('~/components/layouts/PopUpLoading'),
    PopUpMobileMenu: () => import('~/components/layouts/PopUpMobileMenu'),
    PopUpFastBuy: () => import('~/components/layouts/PopUpFastBuy'),
    PopUpCmsPage: () => import('~/components/layouts/PopUpCmsPage'),
    ButtonScrollTop: () => import('~/components/layouts/ButtonScrollTop'),
    PopUpNotification: () => import('~/components/layouts/PopUpNotification'),
  },

  mounted: async function () {
    await this.getCart();
    // this.openNotificationWorkTime();
    this.openCookieConsent();
  },

  methods: {
    openCookieConsent: function () {
      const container = document.querySelector(".сonsent");
      container.classList.add('сonsent--active');
      if (document.cookie.indexOf('сonsent') !== -1) {
        container.classList.remove('сonsent--active');
      }

      if (document.querySelector(".сonsent")) {
        const apply = container.querySelector(".сonsent__apply");
        apply.addEventListener('click', () => {
          container.classList.remove('сonsent--active');
          document.cookie = 'сonsent=true; max-age=2592000; path=/';
        });
      };
    },
    openNotificationWorkTime: function () {
      // const isView = this.$coo;

      // this.$store.commit('pop-up-notification/open', {
      //   title: 'Уведомление',
      //   message: 'По техническим причинам колесное ателье 2000Колес работает 13.12.2023 до 18.00, 14.12.2023 с 12.00. Вы можете оставить заказ на сайте, он обязательно будет обработан в рабочее время.',
      // });
    },
  },
};
